import { template as template_aad3e4ba628244dd93c5c95e18704e87 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { modifier } from 'ember-modifier';
import RouteTemplate from 'ember-route-template';
import CardPrerender from '@cardstack/host/components/card-prerender';
interface ApplicationRouteSignature {
    Args: {
    };
}
const ApplicationRouteComponent: TemplateOnlyComponent<ApplicationRouteSignature> = template_aad3e4ba628244dd93c5c95e18704e87(`
    {{outlet}}
    <CardPrerender />

    {{! this is a signal for the Realm DOM tests to know that app has loaded }}
    {{! template-lint-disable no-inline-styles }}
    <div data-test-boxel-root style='display: none;' {{removeLoading}}></div>
  `, {
    eval () {
        return eval(arguments[0]);
    }
});
let removeLoading = modifier(()=>{
    document.querySelector('#host-loading')?.remove();
});
export default RouteTemplate(ApplicationRouteComponent);
